import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {black500, greyishBlue500} from "assets/jss/main";

MobileCustomerInfos.propTypes = {
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    isGuest: PropTypes.bool.isRequired,
    totalOrderCount: PropTypes.number.isRequired
};

const StartIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.15327 2.34L10.3266 4.68667C10.4866 5.01333 10.9133 5.32667 11.2733 5.38667L13.3999 5.74C14.7599 5.96666 15.0799 6.95333 14.0999 7.92667L12.4466 9.58C12.1666 9.86 12.0133 10.4 12.0999 10.7867L12.5733 12.8333C12.9466 14.4533 12.0866 15.08 10.6533 14.2333L8.65994 13.0533C8.29994 12.84 7.70661 12.84 7.33994 13.0533L5.34661 14.2333C3.91994 15.08 3.05327 14.4467 3.42661 12.8333L3.89994 10.7867C3.98661 10.4 3.83327 9.86 3.55327 9.58L1.89994 7.92667C0.926606 6.95333 1.23994 5.96666 2.59994 5.74L4.72661 5.38667C5.07994 5.32667 5.50661 5.01333 5.66661 4.68667L6.83994 2.34C7.47994 1.06666 8.51994 1.06666 9.15327 2.34Z" fill="#FBD83C"/>
    </svg>
);

const HeartIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9597 2.06667C9.75301 2.06667 8.67301 2.65333 7.99967 3.55333C7.32634 2.65333 6.24634 2.06667 5.03967 2.06667C2.99301 2.06667 1.33301 3.73333 1.33301 5.79333C1.33301 6.58667 1.45967 7.32 1.67967 8C2.73301 11.3333 5.97967 13.3267 7.58634 13.8733C7.81301 13.9533 8.18634 13.9533 8.41301 13.8733C10.0197 13.3267 13.2663 11.3333 14.3197 8C14.5397 7.32 14.6663 6.58667 14.6663 5.79333C14.6663 3.73333 13.0063 2.06667 10.9597 2.06667Z" fill="#FC3A3F"/>
    </svg>
);

const GuestIcon = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.00033 8C9.84127 8 11.3337 6.50761 11.3337 4.66667C11.3337 2.82572 9.84127 1.33333 8.00033 1.33333C6.15938 1.33333 4.66699 2.82572 4.66699 4.66667C4.66699 6.50761 6.15938 8 8.00033 8Z" stroke="#838B9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.27344 14.6667C2.27344 12.0867 4.84012 10 8.00012 10" stroke="#838B9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.1333 14.2667C13.3115 14.2667 14.2667 13.3115 14.2667 12.1333C14.2667 10.9551 13.3115 10 12.1333 10C10.9551 10 10 10.9551 10 12.1333C10 13.3115 10.9551 14.2667 12.1333 14.2667Z" stroke="#838B9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M14.6667 14.6667L14 14" stroke="#838B9B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

function MobileCustomerInfos({firstName, lastName, isGuest, totalOrderCount}) {
    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: '4px', width: '100%'}}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '4px', width: '100%'}}>
                <span
                    style={{color: black500, fontWeight: 600, fontSize: '14px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}
                    title={`${lastName} ${firstName}`}
                >
                    {lastName} {firstName}
                </span>
                <div style={{display: 'flex', alignItems: 'center', gap: '4px', flexShrink: 0, color: greyishBlue500, fontSize: '14px'}}>
                    {totalOrderCount === 1 ? (
                        <>
                            {StartIcon}
                            <FormattedMessage id='oms.order.list.customerInfos.firstOrder' />
                        </>
                    ) : (
                        <>
                            {HeartIcon}
                            <FormattedMessage id='oms.order.list.customerInfos.orderCount' values={{count: totalOrderCount}} />
                        </>
                    )}
                </div>
            </div>
            {isGuest && (
                <div style={{display: 'flex', alignItems: 'center', gap: '4px', color: greyishBlue500, fontSize: '14px'}}>
                    {GuestIcon}
                    <FormattedMessage id='oms.order.list.customerInfos.guest' />
                </div>
            )}
        </div>
    );
}

export default MobileCustomerInfos;
